module.exports = __webpack_public_path__ + "static/img/mumuqingIcon.26e14df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mumuqingIcon.png
// module id = WRIV
// module chunks = 3